import { TransportModeHelper } from '../../../../helpers/transport-mode.helper';
import { TransportSubModeHelper } from '../../../../helpers/transport-sub-mode.helper';
import { IAccessLink } from '../../../../models/access-link.model';
import type { INote } from '../../../../models/note.model';
import { CoordinateApiModel } from '../coordinate.api-model';
import { CallApiModel } from './call.api-model';
import { LinkEndpointApiModel } from './link-endpoint.api-model';

export class ArrivalAccessLinkApiModel {
  public static mapToBusinessModel(apiModel: ArrivalAccessLinkApiModel): IAccessLink {
    return {
      transportMode: TransportModeHelper.parse(apiModel.transportMode),
      transportSubMode: TransportSubModeHelper.parse(apiModel.transportSubMode),
      origin: CallApiModel.mapToLinkEndpointBusinessModel(apiModel.origin),
      destination: LinkEndpointApiModel.mapToBusinessModel(apiModel.destination),
      notes: apiModel.notes,
      distanceInMeters: apiModel.distanceInMeters,
      linkCoordinates: apiModel.linkCoordinates?.map((coordinate) => CoordinateApiModel.mapToBusinessModel(coordinate)),
      plannedDurationInMinutes: apiModel.plannedDurationInMinutes,
      estimatedDurationInMinutes: apiModel.estimatedDurationInMinutes,
    };
  }

  transportMode!: string;
  transportSubMode!: string;
  origin!: CallApiModel;
  destination!: LinkEndpointApiModel;
  notes?: INote[];
  public plannedDepartureTime?: string;
  public plannedArrivalTime?: string;
  public plannedDurationInMinutes?: number;
  public estimatedDurationInMinutes?: number;
  public estimatedNumberOfSteps?: number;
  public distanceInMeters?: number;
  public linkCoordinates?: CoordinateApiModel[];
}
